import { observer } from 'mobx-react-lite'
import { useRef, useEffect } from 'react'

import { Typography } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { textToHtml } from 'entities/Message/lib/textToHtml'
import { ConversationCard } from 'pages/chatbot/ui/ChatbotDetails/TabConversation/ConversationCard'
import { ActionList } from 'pages/chatbot/ui/ChatbotDetails/TabActions/ActionList'
import { useDetailsContext } from '../detailsContext'
import styles from './styles.module.scss'

export const TabQualify = observer(() => {
  const { qualifyInstruction, qualifiedActions, disqualifiedActions, disqualifiedBehavior } =
    useDetailsContext()
  const entities = useEntitiesContext()
  const value = textToHtml(entities, {
    text: qualifyInstruction,
    replaceNewRow: true,
    extraSpace: true,
  })
  const ref = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (ref.current) {
      ref.current.innerHTML = value
    }
  }, [])

  return (
    <section className={styles.wrap}>
      <ConversationCard
        value={
          qualifyInstruction ? (
            <Typography tag={'div'} variant={'body-rg-regular'} ariaLabel={'TabQualifyTitle'}>
              <span ref={ref} />
            </Typography>
          ) : null
        }
        name={
          <>
            Qualification <br />
            instructions
          </>
        }
        placeholder='-'
      />
      {!!qualifiedActions?.length && (
        <ActionList name='Qualified contacts' actions={qualifiedActions} />
      )}
      <ActionList
        name='Disqualified contacts'
        actions={disqualifiedActions}
        customAction={disqualifiedBehavior}
      />
    </section>
  )
})
